import React from "react";
import "./Footer.css";
import { Phone, Mail, Instagram, Send } from "lucide-react";
import { NavLink } from "react-router-dom";
import { FaViber, FaYoutube, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-block">
          <NavLink to="/" className="footer-logo-link">
            <h2 className="footer-logo">Future Space Realty</h2>
          </NavLink>

          <p className="footer-text">
            Нерухомість для життя та бізнесу. Повна інформація без зайвих
            дзвінків та уточнень.
          </p>
        </div>

        <div className="footer-block">
          <h3>Навігація</h3>
          <ul className="footer-list">
            <li>
              <NavLink to="/" className="footer-link">
                Головна
              </NavLink>
            </li>
            <li>
              <NavLink to="/about" className="footer-link">
                Про Нас
              </NavLink>
            </li>
            <li>
              <NavLink to="/contact" className="footer-link">
                Контакти
              </NavLink>
            </li>
            <li>
              <NavLink to="/management" className="footer-link">
                Управління
              </NavLink>
            </li>
          </ul>
        </div>

        <div className="footer-block">
          <h3>Контакти</h3>
          <p>
            <Phone size={16} />
            <a href="tel:+380678367676" className="footer-contact-link">
              +38 (067) 836 76 76
            </a>
          </p>
          <p>
            <Mail size={16} />
            <a href="mailto:example@gmail.com" className="footer-contact-link">
              example@gmail.com
            </a>
          </p>
        </div>

        <div className="footer-block">
          <h3>Соцмережі</h3>
          <div className="footer-socials">
            <a href="https://www.instagram.com/futurespacerealty/"
             target="_blank">
             <FaInstagram size={20} />
            </a>

            <a href="tg://resolve?domain=Tomas2228"
             target="_blank">
              <Send size={20} />
            </a>

            <a href="viber://chat?number=+380678367676" target="_blank">
              <FaViber size={20} />
            </a>

            <a href="https://www.youtube.com/@futurespacerealty28" target="_blank">
              <FaYoutube size={20} />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        ©2023 - {new Date().getFullYear()} Future Space Realty. Всі права
        захищені.
      </div>
    </footer>
  );
};

export default Footer;